// Events Data
export default [
    {
        title: "New Year Festival",
        location: "Nishiki Market",
        locUrl: "https://www.google.com/maps/place/Nishiki+Market/@35.0049808,135.7626718,17z/data=!3m1!4b1!4m5!3m4!1s0x6001089ccd8ccb4f:0xb69ea31001ec6c9c!8m2!3d35.0049808!4d135.7648605",
        description:
            "Check all the food and games in our stunning Nigth festival, perfect fit for the whole family.",
        month: 1,
        img: "https://images.unsplash.com/photo-1494588024300-e9df7ff98d78?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8amFwYW4lMjBjdWx0dXJlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q",
    },
    {
        title: "New Year Wine showcase",
        location: "Kyoto Station",
        locUrl: "https://www.google.com/maps/place/Kyoto+Station/@34.9849887,135.7569952,16.38z/data=!4m5!3m4!1s0x600108ae918b02ef:0xb61a446e74a21c08!8m2!3d34.985849!4d135.7587667",
        description:
            "Join a personalized tour with a knowledgeable expert in Japanese culture and history.",
        month: 1,
        img: "https://images.unsplash.com/photo-1613590928141-93eb1bbfb59f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fGt5b3RvfGVufDB8MHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 2,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Anime Ky-Con",
        location: "Umekoji Park",
        locUrl: "https://www.google.com/maps/place/Umekoji+Park/@34.9869651,135.743121,17z/data=!4m9!1m2!2m1!1sumekoji+park!3m5!1s0x6001061bce8ed99b:0x32ad976c113178b6!8m2!3d34.9863414!4d135.7463518!15sCgx1bWVrb2ppIHBhcmtaDiIMdW1la29qaSBwYXJrkgEJY2l0eV9wYXJr4AEA",
        description:
            "Anime fan? Can't miss the chance to get original merchandise and interact with other anime fans in the convention.",
        month: 3,
        img: "https://images.unsplash.com/photo-1625189659340-887baac3ea32?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8YW5pbWUlMjBjb252ZW50aW9ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Tea ceremony",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 4,
        img: "https://images.unsplash.com/photo-1480796927426-f609979314bd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 4,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 5,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 5,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 6,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "June Go Carts",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 6,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 7,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 7,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Baseball Training Camp",
        location: "Wakasa Stadium",
        locUrl: "https://www.google.com/maps/place/Wakasa+Stadium+Kyoto/@34.9925758,135.7135698,17z/data=!3m1!4b1!4m5!3m4!1s0x60010655c6985de7:0xd6a801788364ae24!8m2!3d34.9925714!4d135.7157585",
        description:
            "Train with an experienced coach to improve your homerun skills!",
        month: 8,
        img: "https://images.unsplash.com/photo-1578432014316-48b448d79d57?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8YmFzZWJhbGx8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Kurama Fire Festival",
        location: "Kurama Station",
        locUrl: "https://www.google.com/maps/place/Kurama+Station/@35.112925,135.772521,17z/data=!3m1!4b1!4m5!3m4!1s0x6001a66ae18766a9:0xbd117d7fe527f213!8m2!3d35.112925!4d135.772521",
        description:
            "The lighting of lanterns in front of each house at sunset is the starting point for the Kurama Fire Festival.",
        month: 8,
        img: "https://images.unsplash.com/photo-1546603999-24fbcb911bee?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fGZpcmUlMjBmZXN0aXZhbHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 9,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Night Matsuri",
        location: "South Market",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Visit all the stands and eat all the food in the festival.",
        month: 10,
        img: "https://images.unsplash.com/photo-1565618991703-cdddef2bad22?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8eXVrYXRhfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Fall Firewors",
        location: "Shinji Bay",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description: "Enjoy an splending firework show near the sea.",
        month: 10,
        img: "https://images.unsplash.com/photo-1531686264889-56fdcabd163f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 10,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Geisha District Festival",
        location: "Gion",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Attend the bi-annual festival to celebreta the Geisha culture",
        month: 11,
        img: "https://images.unsplash.com/photo-1505440484611-23c171ad6e96?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Z2Vpc2hhfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Montain Bike Track",
        location: "The Bamboo Forest",
        locUrl: "https://www.google.com/maps/place/Kyoto+Bike+Tour+-+The+Bamboo+Forest+%26+Arashiyama/@35.0194942,135.670815,18z/data=!3m1!4b1!4m5!3m4!1s0x6001a99346427e6f:0xd42663eba40842ac!8m2!3d35.0194942!4d135.6719093",
        description:
            "Kyoto's scenic nature and mountains are perfect for an unforgettable bike tour.",
        month: 11,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Fireworks Late Year",
        location: "Bishamondo",
        locUrl: "https://www.google.com/maps/place/Bishamondo/@34.9759688,135.7756652,12.53z/data=!4m13!1m7!3m6!1s0x6001062b6f570db9:0x408c4afef6d460fd!2sNakagyo+Ward,+Kyoto,+Japan!3b1!8m2!3d35.0116367!4d135.7449914!3m4!1s0x60010eae25b65023:0x897a2d844031d584!8m2!3d35.0011831!4d135.8186824",
        description: "Enjoy a yearly event of fireworks and special effects.",
        month: 12,
        img: "https://images.unsplash.com/photo-1575548393466-0df1618ba410?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
    },
    {
        title: "Samurai Experience",
        location: "Nakagyo Ward",
        locUrl: "https://www.google.com/maps/place/Nakagyo+Ward,+Kyoto,+Japan/@35.0093613,135.7129571,13z/data=!3m1!4b1!4m5!3m4!1s0x6001062b6f570db9:0x408c4afef6d460fd!8m2!3d35.0116367!4d135.7449914",
        description:
            "Try your hand at being a samurai for the day during an experience designed for the whole family",
        month: 12,
        img: "https://images.unsplash.com/photo-1583684977172-528983104c31?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8c2FtdXJhaXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
    },
];
